<template>
  <div>
    <b-row class="py-3">
      <b-col>
        <h4>OVER<b>VIEW</b></h4>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="chart-col"><canvas id="order-stats-chart"></canvas></b-col>
    </b-row>
    <b-row>
      <b-col class="pt-2" style="text-align:right;">Time Period:</b-col>
      <b-col><b-form-select v-model="selectedperiod" :options="periodopts" @input="buildScreen()"></b-form-select></b-col>
    </b-row>
  </div>
</template>


<script>
import Chart from 'chart.js'
import orderStatsData from '@/reports/dash-order-stats.js'
export default {
  name: "OrderStatsChart",
  data() {
    return {
      orderstats: [],
      orderStatsData,
      showoverlay: false,
      selectedperiod: 'daily',
      periodopts: ['daily', 'weekly', 'monthly']
    };
  },

  computed: {

  },

  methods: {
    createChart(chartId, chartData) {
      const ctx = document.getElementById(chartId);
      const myChart = new Chart(ctx, {
        type: chartData.type,
        data: chartData.data,
        options: chartData.options,
      });
      return myChart;
    },

    async fetchStats() {
      this.showoverlay = true;
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      // Use Axios to make a call to the API
      const { data } = await this.$api.get("dashboard/order-stats?period="+this.selectedperiod, {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      this.orderstats = data.orderstats;
      this.showoverlay = false;
    },

    setLabels() {
      this.orderStatsData.data.labels = this.orderstats.map(st=>st.time_period);
    },

    setOrderCount() {
      this.orderStatsData.data.datasets[1].data = this.orderstats.map(st=>st.order_count)
      this.orderStatsData.data.datasets[1].label = 'Number of Orders';
      this.orderStatsData.data.datasets[1].backgroundColor = Array(this.orderstats.length).fill('rgba(170, 200, 255, 1)');
    },

    setOrderTotal() {
      this.orderStatsData.data.datasets[0].data = this.orderstats.map(st=>st.gross_sales/100);
      this.orderStatsData.data.datasets[0].label = 'Gross Sales (x100 $)';
    },

    setAvgOrders() {
      this.orderStatsData.data.datasets[2].data = this.orderstats.map(st=>st.average_order);
      this.orderStatsData.data.datasets[2].label = 'Avg $ per Order';
    },

    emitPeriodChange() {
      this.$emit('emit-stat-period', this.selectedperiod);
    },

    async buildScreen() {
      await this.fetchStats();
      this.buildChartData();
    },

    buildChartData() {
      this.setLabels();
      this.setOrderCount();
      this.setOrderTotal();
      // this.setAvgOrders();
      this.createChart('order-stats-chart', this.orderStatsData);
    }

  },

  created() {
    // this.fetchStats();
    this.buildScreen();
  },

  mounted() {
  }


};
</script>
<style>

  .chart-col {
    height: 300px;
  }

  /* @media (max-width: 767px) {
    .chart-col {
      height: 300px;
    }
  } */

</style>
